export const dashboardPagesMenu = {
    dashboard: {
        id: 'dashboard',
        text: 'Início',
        path: '/',
        icon: 'Dashboard',
        subMenu: null,
    },
};

export const demoPagesMenu = {
    auth: {
        id: 'auth',
        text: 'Auth Pages',
        icon: 'Extension',
    },
    login: {
        id: 'login',
        text: 'Login',
        path: 'auth-pages/login',
        icon: 'Login',
    },
    signUp: {
        id: 'signUp',
        text: 'Sign Up',
        path: 'auth-pages/sign-up',
        icon: 'PersonAdd',
    },
    page404: {
        id: 'Page404',
        text: '404 Page',
        path: 'auth-pages/404',
        icon: 'ReportGmailerrorred',
    },
    firstAccess: {
        id: 'firstAccess',
        text: 'Primeiro Acesso',
        path: 'auth-pages/first-access',
        icon: 'Security',
    },
    token: {
        id: 'token',
        text: 'Código de Acesso',
        path: 'auth-pages/token',
        icon: 'Security',
    },
};

export const pageLayoutTypesPagesMenu = {
    layoutTypes: {
        id: 'layoutTypes',
        text: 'Page Layout Types',
    },
    blank: {
        id: 'blank',
        text: 'Blank',
        path: 'page-layouts/blank',
        icon: 'check_box_outline_blank ',
    },
    pageLayout: {
        id: 'pageLayout',
        text: 'Page Layout',
        path: 'page-layouts',
        icon: 'BackupTable',
        subMenu: {
            headerAndSubheader: {
                id: 'headerAndSubheader',
                text: 'Header & Subheader',
                path: 'page-layouts/header-and-subheader',
                icon: 'ViewAgenda',
            },
            onlyHeader: {
                id: 'onlyHeader',
                text: 'Only Header',
                path: 'page-layouts/only-header',
                icon: 'ViewStream',
            },
            onlySubheader: {
                id: 'onlySubheader',
                text: 'Only Subheader',
                path: 'page-layouts/only-subheader',
                icon: 'ViewStream',
            },
            onlyContent: {
                id: 'onlyContent',
                text: 'Only Content',
                path: 'page-layouts/only-content',
                icon: 'WebAsset',
            },
        },
    },
    asideTypes: {
        id: 'asideTypes',
        text: 'Aside Types',
        path: 'aside-types',
        icon: 'Vertical Split',
        subMenu: {
            defaultAside: {
                id: 'defaultAside',
                text: 'Default Aside',
                path: 'aside-types/default-aside',
                icon: 'ViewQuilt',
            },
            minimizeAside: {
                id: 'minimizeAside',
                text: 'Minimize Aside',
                path: 'aside-types/minimize-aside',
                icon: 'View Compact',
            },
        },
    },
};

export const productsExampleMenu = {
    companyA: { id: 'companyA', text: 'Company A', path: 'grid-pages/products', subMenu: null },
    companyB: { id: 'companyB', text: 'Company B', path: '/', subMenu: null },
    companyC: { id: 'companyC', text: 'Company C', path: '/', subMenu: null },
    companyD: { id: 'companyD', text: 'Company D', path: '/', subMenu: null },
};

export const appMenu = {
    registers: {
        id: 'registers',
        text: 'Cadastros',
        path: 'registers',
        icon: 'LibraryAdd',
        subMenu: {
            companies: {
                id: 'companies',
                text: 'Empresas',
                path: 'registers/companies',
                icon: 'Store',
            },
            costCenters: {
                id: 'costCenters',
                text: 'Centros de custo',
                path: 'registers/costCenters',
                icon: 'AttachMoney',
            },
            jobTitles: {
                id: 'jobTitles',
                text: 'Funções',
                path: 'registers/jobTitles',
                icon: 'Work',
            },
            workResources: {
                id: 'workResources',
                text: 'Ferramentas e EPI',
                path: 'registers/workResources',
                icon: 'Build',
            },
            employees: {
                id: 'employees',
                text: 'Colaboradores',
                path: 'registers/employees',
                icon: 'PeopleAlt',
            },
            trainings: {
                id: 'trainings',
                text: 'Treinamentos',
                path: 'registers/trainings',
                icon: 'School',
            },
            surveys: {
                id: 'surveys',
                text: 'Questionários',
                path: 'registers/surveys',
                icon: 'Feed',
            },
            customers: {
                id: 'customers',
                text: 'Clientes',
                path: 'registers/customers',
                icon: 'AccountCircle',
            },
            permissions: {
                id: 'permissions',
                text: 'Permissões',
                path: 'registers/permissions',
                icon: 'Lock',
            },
            services: {
                id: 'services',
                text: 'Serviços',
                path: 'registers/services',
                icon: 'DesignServices',
            },
        },
    },
    operations: {
        id: 'operation',
        text: 'Operação',
        path: 'operation',
        icon: 'Grain',
        subMenu: {
            surveys: {
                id: 'surveys',
                text: 'Questionários',
                path: 'operation/surveys',
                icon: 'Feed',
            },
            expiringWorkResources: {
                id: 'expiringWorkResources',
                text: 'Venc. Ferramentas e EPI',
                path: 'operation/expiringWorkResources',
                icon: 'CalendarToday',
            },
            workOrders: {
                id: 'workOrders',
                text: 'Ordens de Serviço',
                path: 'operation/workOrders',
                icon: 'InsertDriveFile',
            },
        },
    },
};

export const hiddenMenu = {
    workResourceEmployees: {
        id: 'workResourceEmployees',
        text: 'Ferramentas e EPI do colaborador',
        path: 'work-resource-employee/:id',
        icon: 'Lock',
    },
    trainingEmployees: {
        id: 'trainingEmployees',
        text: 'Treinamentos do Colaborador',
        path: 'training-employee/:id',
        icon: 'Lock',
    },
    surveySettings: {
        id: 'surveyDetails',
        text: 'Detalhes do Questionário',
        path: 'survey-settings/:id',
        icon: 'Assessment',
    },
    answeredSurveyDetail: {
        id: 'answeredSurveyDetail',
        text: 'Detalhes do Questionário Respondido',
        path: 'answered-survey-settings/:id',
        icon: 'Grain',
    },
    workOrderDetail: {
        id: 'workOrderDetail',
        text: 'Detalhes da Ordem de Serviço',
        path: 'work-order-settings/:id',
        icon: 'Grain',
    },
        workOrderView: {
        id: 'workOrderView',
        text: 'Visualizar da Ordem de Serviço',
        path: 'work-order-view',
        icon: 'Grain',
    },
};
